import { createResource, createEditor, createBatch, JsonRestMiddleware } from 'redux-saga-resources';
import { authMiddleware } from '../auth/resource';
import { noteServiceUserApi } from '../settings';
import { IParticipantId } from '../types';

function* customUrls({ request, list }: any, next: any) {
    if (list) {
        request.url = `${noteServiceUserApi}/participant`;
        request.params = {};
    }
    yield* next();
}

export const useridResource = createResource<IParticipantId>('participantid', {}, JsonRestMiddleware(`${noteServiceUserApi}`, authMiddleware, customUrls));
export const useridEditor = createEditor<IParticipantId>('participantid', { createImmediately: false }, useridResource);
export const useridBatch = createBatch<IParticipantId>('participantid', {}, useridResource);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/participantid/resource.tsx